import { fetchFieldAppTracking } from "./fieldAppApi";
import {
  dayKeysNewestFirst,
  selectionForDayKey,
} from "./fieldAppPeriodUtils";
import {
  buildTrackingCacheKey,
  getCachedTracking,
  setCachedTracking,
} from "./fieldAppTrackingCache";
import {
  hasDisplayableTracking,
  mergeTrackingPayloads,
} from "./fieldAppTrackingMerge";

async function fetchTrackingDay(farmId, selection, dayKey) {
  const daySelection = selectionForDayKey(selection, dayKey);
  const cacheKey = buildTrackingCacheKey(farmId, daySelection);
  const cached = getCachedTracking(cacheKey);
  if (cached) return cached;

  const data = await fetchFieldAppTracking(farmId, daySelection);
  if (data) {
    setCachedTracking(cacheKey, data);
  }
  return data;
}

export async function fetchTrackingProgressive(
  farmId,
  selection,
  { onProgress, isCancelled } = {}
) {
  const dayKeys = dayKeysNewestFirst(selection.dateFrom, selection.dateTo);
  if (!dayKeys.length) {
    return null;
  }

  if (dayKeys.length === 1) {
    const data = await fetchTrackingDay(farmId, selection, dayKeys[0]);
    if (onProgress) {
      onProgress({
        tracking: data,
        loadedDays: 1,
        totalDays: 1,
        dayKey: dayKeys[0],
        complete: true,
      });
    }
    return data;
  }

  const partials = [];
  let loadedDays = 0;

  for (const dayKey of dayKeys) {
    if (isCancelled && isCancelled()) {
      return mergeTrackingPayloads(partials);
    }

    let dayData = null;
    try {
      dayData = await fetchTrackingDay(farmId, selection, dayKey);
    } catch (error) {
      console.error(`Falha ao carregar rastreamento do dia ${dayKey}`, error);
    }

    loadedDays += 1;
    if (dayData) {
      partials.push(dayData);
    }

    const tracking = mergeTrackingPayloads(partials);
    const complete = loadedDays >= dayKeys.length;

    if (onProgress) {
      onProgress({
        tracking,
        loadedDays,
        totalDays: dayKeys.length,
        dayKey,
        complete,
      });
    }
  }

  return mergeTrackingPayloads(partials);
}

export { hasDisplayableTracking };
